// import axios from 'services/axios';
import { default as mockAxios } from 'utils/axios';
// import { API } from 'services/constants';

const createAction = name => ({
  GET_BILLING_PENDING: `${name}_GET_BILLING_PENDING`,
  GET_BILLING_SUCCESS: `${name}_GET_BILLING_SUCCESS`,
  GET_BILLING_FAILED: `${name}_GET_BILLING_FAILED`,
  GET_BILLING_PDF_DATA_PENDING: `${name}_GET_BILLING_PDF_DATA_PENDING`,
  GET_BILLING_PDF_DATA_SUCCESS: `${name}_GET_BILLING_PDF_DATA_SUCCESS`,
  GET_BILLING_PDF_DATA_FAILED: `${name}_GET_BILLING_PDF_DATA_FAILED`,
  PDF_IS_READY: `${name}_PDF_IS_READY`,
  PDF_NOT_READY: `${name}_PDF_NOT_READY`
});

export const BILLING = createAction('BILLING');

export const GetMockBilling = () => async (dispatch, getState) => {
  dispatch({ type: BILLING.GET_BILLING_PENDING });
  try {
    const result = await mockAxios
      .get('/api/billing')
      .then(res => res.data)
      .catch(err => Promise.reject(err));

    dispatch({
      type: BILLING.GET_BILLING_SUCCESS,
      payload: result
    });
  } catch (error) {
    dispatch({
      type: BILLING.GET_BILLING_FAILED,
      error
    });
  }
};

export const GetMockBillingPDFData = () => async (dispatch, getState) => {
  dispatch({ type: BILLING.GET_BILLING_PDF_DATA_PENDING });
  try {
    const result = await mockAxios
      .get('/api/billing/1')
      .then(res => res.data)
      .catch(err => Promise.reject(err));

    dispatch({
      type: BILLING.GET_BILLING_PDF_DATA_SUCCESS,
      payload: result.data
    });
  } catch (error) {
    dispatch({
      type: BILLING.GET_BILLING_PDF_DATA_FAILED,
      error
    });
  }
};

export const BillingPdfIsReady = () => dispatch => {
  dispatch({ type: BILLING.PDF_IS_READY });
};

export const BillingPdfNotReady = () => dispatch => {
  dispatch({ type: BILLING.PDF_NOT_READY });
};
